import { render, staticRenderFns } from "./classConfigService1.vue?vue&type=template&id=210fdd1e&scoped=true&"
import script from "./classConfigService1.vue?vue&type=script&lang=ts&"
export * from "./classConfigService1.vue?vue&type=script&lang=ts&"
import style0 from "./classConfigService1.vue?vue&type=style&index=0&id=210fdd1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fdd1e",
  null
  
)

export default component.exports